export function isValidDate(date: Date | null): date is Date {
  return date instanceof Date && !Number.isNaN(date.getTime());
}
